export const REGISTER_STATUS = {
  PENDING: 'PENDING',
  COMPLETED_LOADING: 'COMPLETED_LOADING',
  COMPLETED_SUCCESS: 'COMPLETED_SUCCESS',
  COMPLETED_REJECTED: 'COMPLETED_REJECTED'
}
